import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const search = (searchObject: Object) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.claimMember.isPosting) { return Promise.reject(); }

  dispatch({ type: types.SEARCH_CLAIM_MEMBERS_REQUEST });

  return api.claim.member.search(searchObject)
    .then((res: any) => {

      dispatch({
        type: types.SEARCH_CLAIM_MEMBERS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.SEARCH_CLAIM_MEMBERS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getAttachments = (claimNo: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_CLAIM_MEMBER_ATTACHMENTS_REQUEST });

  return api.claim.member.getAttachments(claimNo, companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_CLAIM_MEMBER_ATTACHMENTS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_CLAIM_MEMBER_ATTACHMENTS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getAuthDetail = (membKeyId: string, provKeyId: string, authNo: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_CLAIM_MEMBER_AUTH_DETAIL_REQUEST });

  return api.claim.member.getAuthDetail(membKeyId, provKeyId, authNo)
    .then((res: any) => {

      dispatch({
        type: types.GET_CLAIM_MEMBER_AUTH_DETAIL_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_CLAIM_MEMBER_AUTH_DETAIL_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
  